import * as React from 'react'

const ChevronUp = props => (
  <svg width="24" height="8" viewBox="0 0 24 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 6L12 2L22 6" stroke="#3C52EF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default ChevronUp
